<template>
  <div>
    <b-card
      v-show="resettingpassword==false && user_id != 0"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </b-card-title>
      <h4>Reset password</h4>
      <b-form
        autocomplete="off"
        @submit.prevent="resetpassword"
      >
        <b-form-group
          label="Enter your new password"
          invalid-feedback="Password must not be blank and must be the same as the repeat password"
        >
          <b-form-input
            v-model="i_password"
            autocomplete="off"
            type="password"
            :state="i_password_valid"
          />
        </b-form-group>
        <b-form-group
          label="Repeat your new password"
          invalid-feedback="Repeat password must not be blank and must be the same as the password"
        >
          <b-form-input
            v-model="i_password_repeat"
            autocomplete="off"
            type="password"
            :state="i_password_repeat_valid"
          />
        </b-form-group>
        <div class="col-12 mx-auto text-center">
          <b-button
            class="col-6"
            type="submit"
            variant="primary"
          >
            <span class="icon-key mr-2" />Update your password
          </b-button>
        </div>
      </b-form>
    </b-card>
    <b-card
      v-show="resettingpassword==true && user_id != 0"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </b-card-title>
      <b-alert
        variant="success"
        show
      >
        Your password has been reset<br><br>
        <b-button
          class="col-12 col-sm-6"
          variant="primary"
          @click.prevent="gotologin"
        >
          <span class="icon-key ml-2 mr-2" />Go to login
        </b-button>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
export default {
  name: 'ResetPassword',
  components: {
  },
  data () {
    return {
      token: this.$route.params.t,
      user_id: 0,
      i_password: '',
      i_password_valid: true,
      i_password_repeat: '',
      i_password_repeat_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      message: ''
    }
  },
  mounted () {
    this.getuserid()
  },
  methods: {
    gotologin() {
      this.$router.push('/');
    },
    getuserid () {
      this.$store.dispatch('userbytoken_fetch', { token: this.token })
      .then((resp) => {
        this.user_id = resp.data.i
      })
    },
    resetpassword () {
      var formok = true
      if (this.i_password == '') {
        this.i_password_valid = false
        formok = false
      }
      if (this.i_password_repeat == '') {
        this.i_password_repeat_valid = false
        formok = false
      }
      if (this.i_password != this.i_password_repeat) {
        this.i_password_valid = false
        this.i_password_repeat_valid = false
        formok = false
      }
      if (formok) {
        this.savefield('i_user', this.user_id, 'i_password', this.i_password)
        this.resettingpassword = true
      }
    },
    savefield (tablename, id, fieldname, value) {
      if (id > 0) {
        var record = {
          id: id,
          [fieldname]: value,
          token: this.token
        }
        return this.$store.dispatch('resetpassword_save', { user: record })
      }
    }
  }
}
</script>
<style>
</style>
